import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  acceptInvitation(token: string, accepted: boolean, email: string): Observable<any> {
    const params = new HttpParams()
      .set('token', token)
      .set('accepted', accepted.toString())
      .set('email', email);

    return this.http.get<any>(`${this.apiUrl}/invitations/accept-or-declined`, {params});
  }
}
